import React from "react";

export default function About() {
  return (
    <div className="main-container">
      <img src="/logo-foxorox.png" alt="Foxorox Logo" className="logo" />
      <h1 className="highlight">About Foxorox</h1>
      <p className="subtitle">
        Foxorox combines 35+ years of trading experience with cutting-edge AI to deliver accurate and actionable stock market insights. Our platform empowers investors with tools previously reserved for institutions.
      </p>
    </div>
  );
}